// extracted by mini-css-extract-plugin
export default {"container":"AddCustom--container--c3def6","label":"AddCustom--label--39faac"};